(function ($) {

    function videoStateChange() {
        const videos = $('video');

        videos.each(function(i, element) {
            $(element).on('play', function(e) {
                videos.not($(element)).each(function(i, ele) {
                    ele.pause();
                });
            });
        });
    }

    videoStateChange();

    if(window.barba !== undefined) {
        barba.hooks.enter((data) => {
            videoStateChange();
        });
    }   
})(jQuery);